import React, { PureComponent } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import { withCookies } from 'react-cookie';
import {
  loadMemorialFundraisersPageData,
  selectMemorialPageData,
} from '@client/pages/memorialFundraisersPage/duckMemorialFundraisersPage';
import MoreFromHlf from '@client/containers/moreFromHlf/MoreFromHlf';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { selectServerRequestInfo } from '@client/redux/requestState/requestStateReducer';
import ReactLink from '@client/components/reactLink/ReactLink';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import Image from '@client/components/image/Image';
import Markdown from '@client/components/markdown/Markdown';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import FundraiserCard from '@client/containers/fundraiserCard/FundraiserCard';
import {
  selectDefaultDescriptionText,
  selectFundraiser,
} from '@client/redux/fundraiser/fundraiserSelectors';
import ArticleCard from '@client/containers/articleCard/ArticleCard';
import { Auth0Context } from '@client/helperComponents/react-auth0-spa';
import styles from './memorialFundraisersPage.scss';

class MemorialFundraisersPage extends PureComponent {
  static contextType = Auth0Context;

  constructor(props) {
    super(props);
  }
  static loadData(dispatch, urlLocation, matchParams) {
    return dispatch(loadMemorialFundraisersPageData());
  }

  componentDidMount() {
    MemorialFundraisersPage.loadData(this.props.dispatch);
  }

  getShareUrl = () => {
    const { location, serverRequestInfo } = this.props;

    return getIn(serverRequestInfo, 'origin') + location.pathname;
  };

  handleAuthRouteChange = (event) => {
    if (!this.context.isAuthenticated) {
      event.preventDefault();
      event.stopPropagation();

      const url = `/skapa/insamling?type=2`;

      this.context.loginWithRedirect({
        appState: { targetUrl: url },
      });
    }
  };

  render() {
    const { pageData, fundraiser, defaultDescriptionText } = this.props;

    const fundraisers = getIn(fundraiser, 'results');

    const numberOfFundraisers = getIn(fundraiser, 'totalCount');

    const articles = getIn(pageData, 'articles')
      ? getIn(pageData, 'articles').map((each) => getIn(each, 'fields'))
      : undefined;

    const headerImage = getIn(pageData, 'headerImage', 'fields', 'file', 'url');

    return (
      <div className={styleHelper.flexCol}>
        <div
          className={`${styleHelper.contentContainer} ${styles.memorialFundraisersPage}`}
        >
          <div className={`${styles.headerContainer}`}>
            <div className={styles.centerContainer}>
              <h1 className={`${styleHelper.titleLgPrimary} ${styles.title}`}>
                {getIn(pageData, 'title')}
              </h1>
              <h3
                className={`${styleHelper.titleMdPrimary} ${styles.subtitle}`}
              >
                {getIn(pageData, 'subtitle')}
              </h3>
            </div>
            {headerImage && (
              <Image className={styles.image} src={headerImage} />
            )}
          </div>
          <div
            className={`${styleHelper.layoutMobileAndTabletSidePadding} ${styles.description}`}
          >
            <h4
              className={`${styleHelper.titleMdPrimary} ${styles.descriptionTitle}`}
            >
              {getIn(pageData, 'titleDescription')}
            </h4>
            <Markdown value={valueOrEmptyStr(getIn(pageData, 'description'))} />
            <ReactLink
              className={`${styleHelper.btnPrimaryLg}`}
              to={`/skapa/insamling?type=2`}
              onClick={this.handleAuthRouteChange}
            >
              {getIn(pageData, 'createMemorialFundButton')}
            </ReactLink>
          </div>
          {articles && (
            <div className={`${styles.articlesContainer}`}>
              <div className={styleHelper.alignmentContainer}>
                <div className={styleHelper.grid13}>
                  {articles &&
                    articles.map((article, index) => {
                      return (
                        <ArticleCard key={index} article={article} fluidImage />
                      ); //TODO Fix key prop
                    })}
                </div>
              </div>
            </div>
          )}
          <hr className={styles.hr} />
          {numberOfFundraisers > 0 && (
            <div className={`${styles.fundraisers}`}>
              <h2
                className={`${styleHelper.titleMdPrimary} ${styles.title} ${styleHelper.layoutMobileSidePadding}`}
              >
                Minnesfonder
              </h2>
              <div className={styleHelper.alignmentContainer}>
                <div className={styleHelper.cardListGrid}>
                  {fundraisers &&
                    numberOfFundraisers > 0 &&
                    fundraisers.slice(0, 3).map((fundraiser) => {
                      return (
                        <FundraiserCard
                          key={getIn(fundraiser, 'id')}
                          fundraiser={fundraiser}
                          defaultDescriptionText={defaultDescriptionText}
                        />
                      );
                    })}
                </div>
              </div>
              <ReactLink
                className={`${styles.showMoreFundraisersLink}`}
                to={`/?FundraiserType=2#listing`}
              >
                {getIn(pageData, 'seeMoreLink')}
              </ReactLink>
            </div>
          )}
        </div>
        <MoreFromHlf className={styles.section} />
      </div>
    );
  }
}

MemorialFundraisersPage.propTypes = {
  location: PropTypes.object,
  serverRequestInfo: ImmutablePropTypes.map,
  dispatch: PropTypes.func,
  pageData: ImmutablePropTypes.map,
  fundraiser: ImmutablePropTypes.map,
  defaultDescriptionText: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    serverRequestInfo: selectServerRequestInfo(state),
    pageData: selectMemorialPageData(state),
    fundraiser: selectFundraiser(state),
    defaultDescriptionText: selectDefaultDescriptionText(state, 'MemorialFund'),
  };
}

export default withRouter(
  connect(mapStateToProps)(withCookies(MemorialFundraisersPage))
);
